import { useTranslation, } from "react-i18next";
import * as yup from 'yup';


const Validate = {
    LoginValidate,
    ForgotValidate,
    NewPassValidate,
    IpSeqSearchValidate,
    InformationDataValidate,
    ChangePasswordValidate,
    AntibodySearchValidation,
    MergeResultsValidate,
    validateFastaInput
};

function LoginValidate() {
    const { t } = useTranslation('common');
    const validationSchema = yup.object({
        userName: yup
            .string(t('enterconfirmPassword'))
            //.matches('/^[_0-9a-zA-Z.@\\-\']+$/i', 'Illegal character in login name.')
            .required(t('userNameReq')),
        password: yup
            .string(t('enterPass'))
            //.min(9, 'Password is too short - should be 9 chars minimum.')
            //.min(20, 'Password is too long - should be 20 chars maximum.')
            //.matches("^(?=.*[a-z])", 'Password should contain at least one lowercase letter.')
            //.matches("^(?=.*[A-Z])", 'Password should contain at least one uppercase letter.')
            //.matches("^(?=.*[0-9])", 'Password should contain at least one numbers.')
            // .min(8, t('passMinChar'))
            .required(t('passwordReq')),
    });
    return validationSchema;
}

function validateFastaInput(input) {
        if (!input.trim()) return { error: 'Sequence cannot be empty.', warning: null };
        if (/<([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>[\s\S]*?<\/\1>/i.test(input)) {
            return { error: 'HTML tags are not allowed in the sequence input.', warning: null };
        }
        const lines = input.trim().split('\n');
        const sequences = [];
        let currentSeq = { id: '', content: '' };
        for (let line of lines) {
            line = line.trim();
            if (line.startsWith('>')) {
                if (currentSeq.id) sequences.push(currentSeq);
                currentSeq = { id: line, content: '' };
            } else {
                currentSeq.content += line;
            }
        }
        if (currentSeq.id) sequences.push(currentSeq);
        const ids = sequences.map(seq =>
            seq.id.slice(1).split(/[\s,]+/)[0].toLowerCase()
        );
        // Normalize contents: remove all whitespace before lowercasing for duplicate detection
        const normalizedContents = sequences.map(seq => seq.content.replace(/\s+/g, '').toLowerCase());

        // Duplicate ID check - this is an error and blocks submission
        const duplicateId = ids.find((id, idx) => ids.indexOf(id) !== idx);
        if (duplicateId) return { error: `Duplicate sequence ID found: ${duplicateId}`, warning: null };

        // Duplicate content check after normalization - this is a warning (allows submission)
        const duplicateContent = normalizedContents.find((content, idx) => normalizedContents.indexOf(content) !== idx);
        if (duplicateContent) return { error: null, warning: `Duplicate sequence found: ${duplicateContent}` };
        
        return { error: null, warning: null };
    }

function NewPassValidate() {
    const { t } = useTranslation('common');
    const validationSchema = yup.object({
        newPassword: yup
            .string(t('enternewPassword'))
            .min(9, 'Password is too short - should be 9 chars minimum.')
            .matches("^(?=.*[a-z])", 'Password should contain at least one lowercase letter.')
            .matches("^(?=.*[A-Z])", 'Password should contain at least one uppercase letter.')
            .matches("^(?=.*[0-9])", 'Password should contain at least one numbers.')
            .required(t('newPasswordReq')),
        confirmPassword: yup
            .string(t('enterconfirmPassword'))
            .min(9, 'Password is too short - should be 9 chars minimum.')
            .matches("^(?=.*[a-z])", 'Password should contain at least one lowercase letter.')
            .matches("^(?=.*[A-Z])", 'Password should contain at least one uppercase letter.')
            .matches("^(?=.*[0-9])", 'Password should contain at least one numbers.')
            .required(t('confirmPasswordReq')),
    });
    return validationSchema;
}
function ForgotValidate() {
    const { t } = useTranslation('common');
    const validationSchema = yup.object({
        userName: yup
            .string(t('enteruserName'))
            .required(t('userNameReq')),
        captchaCode: yup
            .string(t('codeShown'))
            .required(t('codeReq')),
    });
    return validationSchema;
}
function InformationDataValidate() {
    const { t } = useTranslation('common');
    const validationSchema = yup.object({
        firstName: yup
            .string(t('enterfirstName'))
            .required(t('firstNameReq')),
        lastName: yup
            .string(t('enterlastName'))
            .required(t('lastNameReq')),
        confirmPassword: yup
            .string(t('enterconfirmPassword'))
            .required(t('confirmPasswordReq')),

    });
    return validationSchema;
}
function ChangePasswordValidate() {
    const { t } = useTranslation('common');
    const validationSchema = yup.object({
        currentPassword: yup
            .string(t('entercurrentPassword'))
            .required(t('currentPasswordReq')),
        newPassword: yup
            .string(t('enternewPassword'))
            .min(9, 'Password is too short - should be 9 chars minimum.')
            .matches("^(?=.*[a-z])", 'Password should contain at least one lowercase letter.')
            .matches("^(?=.*[A-Z])", 'Password should contain at least one uppercase letter.')
            .matches("^(?=.*[0-9])", 'Password should contain at least one numbers.')
            .required(t('newPasswordReq')),
        confirmPassword: yup
            // .string(t('enterconfirmPassword'))
            // .min(9, 'Password is too short - should be 9 chars minimum.')
            // .matches("^(?=.*[a-z])", 'Password should contain at least one lowercase letter.')
            // .matches("^(?=.*[A-Z])", 'Password should contain at least one uppercase letter.')
            // .matches("^(?=.*[0-9])", 'Password should contain at least one numbers.')
            // .required(t('confirmPasswordReq'))
            .string().equalTo(yup.ref('newPassword'), t('passAndConfirmNotSame')),


    });
    return validationSchema;
}

function IpSeqSearchValidate(seqType, saveFormValue, searchAlgorithm, isPatientDoc, creditValues) {
    const { t } = useTranslation('common');
    let validationShape = {
        searchDetails: yup
            .string()
            .required(t('searchNameRequired'))
            .max(188, t('188OnlyAllowed'))
            .trim(),
        minResidues: yup
            .number()
            .integer(t('valueMustBeInteger'))
            .required(t('required'))
            .typeError(t('notNumber'))
            .typeError(t('notNumber'))
            .min(3, t('minResiduesNotValid')),
        maxResidues: yup
            .number()
            .integer(t('valueMustBeInteger'))
            .required(t('required'))
            .typeError(t('notNumber'))
            .min(yup.ref('minResidues'), "Max should be more than Min"),
            //.moreThan(yup.ref('minResidues'),"Max should be more than Min"),

        // querySequence: yup
        //     .string()
        //     .required(t('querySeqReq')),
        querySequence: yup
            .string()
            // .required(t('querySeqReq'))
            .validateSeq(t('onlyAlphabetsAllowed'))
            .test('fasta-validate', t('invalidFastaSequence'), function (value) {
                const { path, createError } = this;
                if (!value) return true; // required will catch empty
                const fastaResult = validateFastaInput(value);
                // Only block submission on errors (e.g., duplicate IDs)
                // Warnings (e.g., duplicate content) allow submission
                if (fastaResult.error) {
                    return createError({ path, message: fastaResult.error });
                }
                return true;
            }),
    };

    // Protein && >= 25 amino acids && Single query
    if (seqType && seqType === "protein" && creditValues
        && creditValues.seqCount === 1 && creditValues.resCount >= 25
        && searchAlgorithm && searchAlgorithm === "kerr") {
        //&& genepastPercentageOver && genepastPercentageOver === "QUERY") {
        validationShape.alignments = yup
            .number()
            .integer(t('valueMustBeInteger'))
            .required(t('alignmentsReq'))
            .typeError(t('alignmentsNotNumber'))
            .min(1, t('bestAlignmentNotValid'))
            .max(3000000, t('bestAlignmentNotValid'));
    } else {
        validationShape.alignments = yup
            .number()
            .integer(t('valueMustBeInteger'))
            .required(t('alignmentsReq'))
            .typeError(t('alignmentsNotNumber'))
            .min(1, t('alignmentNotValid'))
            .max(1000000, t('alignmentNotValid'));
    }

    /*if (seqType && seqType == "nucleotide") {
        validationShape.querySequence = yup
            .string()
            .required(t('querySeqReq'))
            .matches(/^[ACGTURYKMSWBDHVNacgturykmswbdhvn]+$/, t("onlyAtgcnAllowed"))
    } else {
        validationShape.querySequence = yup
            .string()
            .required(t('querySeqReq'))
            .matches(/^[aA-zZ\s]+$/, t("onlyAlphabetsAllowed"))
    }*/
    if (saveFormValue) {
        validationShape.formName = yup
            .string()
            .required(t('required'))
            .max(48, t('48OnlyAllowed'))
            .trim()
    }
    if (searchAlgorithm && (searchAlgorithm === "kerr" || searchAlgorithm === "hash")) {
        validationShape.genePastPercentage = yup
            .number()
            .required(t('genePastPercentageReq'))
            .min(65, t('genePastPercentageIncorrect'))
            .max(100, t('genePastPercentageIncorrect'))
            .test('decimal-places', t('genePastPercentageIncorrect'), function(value) {
                if (value === undefined || value === null) return true;
                const decimalPart = value.toString().split('.')[1];
                return !decimalPart || decimalPart.length <= 2;
            })
            .typeError(t('genePastPercentageIncorrect'))
    } else if (searchAlgorithm && searchAlgorithm === "blast") {
        validationShape.expectCutoff = yup
            .number()
            .required(t('expectCutoffRequired'))
            .typeError(t('expectCutoffNotNumber'))
            .min(0, t('expectCutOffErr'))
            .max(1000000, t('expectCutOffErr'))
    } else if (searchAlgorithm && searchAlgorithm === "fragment") {
        validationShape.fragmentStretch = yup
            .number()
            .integer(t('valueMustBeInteger'))
            .required(t('fragmentStretchRequired'))
            .typeError(t('fragmentStretchNotNumber'))
            .min(1, t('fragmentStretchNotNumber'))
        if (seqType && seqType === "nucleotide") {
            validationShape.fragmentAminoAcid = yup
                .number()
                .required(t('fragmentPercentageReq'))
                .min(91, t('fragmentNucPerError'))
                .max(100, t('fragmentNucPerError'))
                .test('decimal-places', t('fragmentNucPerError'), function(value) {
                    if (value === undefined || value === null) return true;
                    const decimalPart = value.toString().split('.')[1];
                    return !decimalPart || decimalPart.length <= 2;
                })
                .typeError(t('fragmentNucPerError'))
            validationShape.fragmentStretch = yup
                .number()
                .integer(t('valueMustBeInteger'))
                .required(t('fragmentStretchRequired'))
                .typeError(t('fragmentStretchNotNumber'))
                .min(10, t('fragNucStretchError'))
                .max(1000, t('fragNucStretchError'))
        } else if (seqType && seqType === "protein") {
            validationShape.fragmentAminoAcid = yup
                .number()
                .required(t('fragmentPercentageReq'))
                .min(81, t('fragmentProPerError'))
                .max(100, t('fragmentProPerError'))
                .test('decimal-places', t('fragmentProPerError'), function(value) {
                    if (value === undefined || value === null) return true;
                    const decimalPart = value.toString().split('.')[1];
                    return !decimalPart || decimalPart.length <= 2;
                })
                .typeError(t('fragmentProPerError'))
            validationShape.fragmentStretch = yup
                .number()
                .integer(t('valueMustBeInteger'))
                .required(t('fragmentStretchRequired'))
                .typeError(t('fragmentStretchNotNumber'))
                .min(5, t('fragProStretchError'))
                .max(1000, t('fragProStretchError'))
        }
    }
    if (isPatientDoc) {
        validationShape.patientDocInp = yup
            .number()
            .integer(t('valueMustBeInteger'))
            .min(1, t('shouldBeGreaterThanZero'))
            .typeError(t('notNumber'))
            .required(t('required'))
    }

    const validationSchema = yup.object().shape(validationShape);

    return validationSchema;
}
yup.addMethod(yup.string, "validateCdr", function (message) {
    // const { message } = args;
    return yup.mixed().test(`validateCdr`, message, function (value) {
        const { path, createError } = this;
        let isValid = true;
        if (value) {
            let isValid = true;
            value = value.replace(/\s+/g, '');
            if (value.length > 64 || value.length < 3) {
                isValid = false;
            } else {
                let letters = /^[A-Za-z]+$/;
                isValid = value.match(letters);
            }
            return isValid || createError({ path, message });
        } else {
            return isValid || createError({ path, message });
        }


    })
})
yup.addMethod(yup.string, "validateMismatch", function (seqType, t) {
    // const { message } = args;
    return yup.mixed().test(`validateMismatch`, function (val, ctx) {
        const { path, createError } = this;
        let text = ctx.parent[seqType];
        const hasSeq = text && text.trim() !== '';
        const isEmpty = val === undefined || val === null || val === '' || val === 'undefined' || Number.isNaN(Number(val));

        if (isEmpty) {
            if (hasSeq) {
                return createError({ path, message: t('required') });
            }
            return true;
        }

        if (!hasSeq) {
            return true;
        }

        const numVal = Number(val);
        let cleanText = text.replace(/\s+/g, '');
        let maxVal = Math.floor(cleanText.length / 5);
        if (!Number.isInteger(numVal) || numVal < 0 || numVal > maxVal) {
            return createError({ path, message: 'Please input a number between 0 and ' + maxVal });
        }
        return true;
    })
})
yup.addMethod(yup.string, "validateStrategy", function (strategyType, t) {
    // const { message } = args;
    return yup.mixed().test(`validateStrategy`, function (val, ctx) {
        const { path, createError } = this;
        let message = '';
        let isValid = true;
        if (val && val !== undefined && val !== 'undefined') {
            // let keyValue = "cdrhcseq"+num;
            let text = ctx.parent[strategyType];
            let isValid = true;
            if ((text === 'genepast' || text === 'hash')
                && (path === "percId" || path === "hcPercId" || path === "lcPercId")) {
                if (val < 65 || val > 100) {
                    isValid = false;
                    message = t('percErr');
                }
            } else {
                if (path === "expectCutoff") {
                    if (val < 0 || val > 100) {
                        isValid = false;
                        message = t('expectCutOffErr');
                    }
                } else if (path === "wordSize") {
                    if (val < 2 || val > 3) {
                        isValid = false;
                        message = t('wordSizeErr');
                    }
                } else if (path === "cdrPercId") {
                    if (val < 65 || val > 100) {
                        isValid = false;
                        message = t('percErr');
                    }
                }
            }
            return isValid || createError({ path, message });
        } else {
            return isValid || createError({ path, message });
        }


    })
})
yup.addMethod(yup.string, "validateSeq", function (message) {
    const { t } = useTranslation('common');
    // const { message } = args;
    return yup.mixed().test(`validateSeq`, message, function (text) {
        const { path, createError } = this;
        let isValid = true;
        let val = 0;
        let returnMsg = '';
        if (text && text !== undefined && text !== 'undefined') {
            if (/<([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>[\s\S]*?<\/\1>/i.test(text)) {
                return createError({ path, message: 'HTML tags are not allowed in the sequence input.' });
            }
            returnMsg = message;
            let lines = text.split(/[\r\n]+/); // split by \n, \r and \r\n, and filter out empty lines
            
            // Check if text contains FASTA sequences (look for > anywhere in text)
            let hasFasta = false;
            let firstFastaIndex = -1;
            for (let i = 0; i < lines.length; i++) {
                if (lines[i].trim().startsWith('>')) {
                    hasFasta = true;
                    if (firstFastaIndex === -1) {
                        firstFastaIndex = i;
                    }
                    break;
                }
            }
            
            if (hasFasta) { // FASTA format detected
                // HC/LC fields expect a raw sequence only - FASTA headers (e.g. ">seq_1") are not allowed
                if (path === "hcFullSeq" || path === "lcFullSeq") {
                    isValid = false;
                    returnMsg = t('fastaNotAllowedHcLc');
                } else {
                    // Check if there's content before the first FASTA marker
                    let hasContentBeforeFasta = false;
                    for (let i = 0; i < firstFastaIndex; i++) {
                        if (lines[i].trim().length > 0) {
                            hasContentBeforeFasta = true;
                            break;
                        }
                    }

                    // If there's content before FASTA, count it as a sequence
                    if (hasContentBeforeFasta) {
                        val++;
                    }

                    // count > numbers (FASTA sequences)
                    for (let i = 0; i < lines.length; i++) {
                        if (lines[i].substring(0, 1) === '>') {
                            val++;
                        }
                    }
                }
            } else if (/^\s*!!/.test(text)) { // ST25
                isValid = false;
            } else if (/^\s*;/.test(text)) { // CIPO
                isValid = true;
            } else if (/^\s*\@/.test(text)) { // Starts with @ but no FASTA - treat as plain text
                // Treat as plain text sequence
                text = ">seq_1\n" + text;
                val = 1;
                isValid = true;
            } 
            else {
                // Appends ">seq_1\n" and treats as FASTA, refer to DlRawSeqdb.php
                text = ">seq_1\n" + text;
                lines = text.split(/[\r\n]+/);
                // count > numbers
                for (let i = 0; i < lines.length; i++) {
                    if (lines[i].substring(0, 1) === '>' && (i + 1) < lines.length && lines[i + 1].substring(0, 1) !== '>') {
                        val++;
                    }
                    if (lines[i].substring(0, 2) === '//') { // EMBL format
                        isValid = false;
                        break;
                    }
                }
            }
            if (val > 1 && path !== 'querySequence') {
                isValid = false;
            }
            return isValid || createError({ path, message: returnMsg });
        } else {
            if (path === 'querySequence' && val === 0) {
                isValid = false;
                returnMsg = t('querySeqReq');
            }
            return isValid || createError({ path, message: returnMsg });
        }

    })
})
function AntibodySearchValidation(saveFormValue) {
    const { t } = useTranslation('common');

    let validationShape = {
        searchName: yup
            .string()
            .required(t('searchNameRequired'))
            .max(188, t('188OnlyAllowed')),
        cdrhcseq1: yup.string()
            .validateCdr(t('sequenceTextErr')),
        // .required(t('cdrhc1Req')),
        cdrhcseq2: yup.string()
            .validateCdr(t('sequenceTextErr')),
        // .required(t('cdrhc2Req')),
        cdrhcseq3: yup.string()
            .validateCdr(t('sequenceTextErr')),
        // .required(t('cdrhc3Req')),
        hcOption1: yup.string()
            .validateMismatch('cdrhcseq1', t),
        hcOption2: yup.string()
            .validateMismatch('cdrhcseq2', t),
        hcOption3: yup.string()
            .validateMismatch('cdrhcseq3', t),
        cdrlcseq1: yup.string()
            .validateCdr(t('sequenceTextErr')),
        // .required(t('cdrhc1Req')),
        cdrlcseq2: yup.string()
            .validateCdr(t('sequenceTextErr')),
        // .required(t('cdrhc2Req')),
        cdrlcseq3: yup.string()
            .validateCdr(t('sequenceTextErr')),
        // .required(t('cdrhc3Req')),
        lcOption1: yup.string()
            .validateMismatch('cdrlcseq1', t),
        lcOption2: yup.string()
            .validateMismatch('cdrlcseq2', t),
        lcOption3: yup.string()
            .validateMismatch('cdrlcseq3', t),
        //percId: yup.string()
            //.validateStrategy('strategy', t),
        hcPercId: yup.string()
            .validateStrategy('strategy', t),
        lcPercId: yup.string()
            .validateStrategy('strategy', t),
        expectCutoff: yup.string()
            .validateStrategy('strategy', t),
        wordSize: yup.string()
            .validateStrategy('strategy', t),
        hcFullSeq: yup.string()
            .validateSeq(t('Invalid Sequence')),
        lcFullSeq: yup.string()
            .validateSeq(t('Invalid Sequence')),
    }
    if (saveFormValue) {
        validationShape.formName = yup
            .string()
            .required(t('required'))
            .max(48, t('48OnlyAllowed'))
            .trim()
    }

    const validationSchema = yup.object().shape(validationShape);
    return validationSchema;
}

yup.addMethod(yup.string, "validateFormName", function (message, isSaveForm) {
    return yup.mixed().test(`validateFormName`, message, function () {
        const { path, createError } = this;
        let isValid = true;
        if (isSaveForm) {
            isValid = false;
        }
        return isValid || createError(path, message)
    })
});

function MergeResultsValidate() {
    const { t } = useTranslation('common');
    const validationSchema = yup.object({
        title: yup
            .string()
            .required(t('required'))
            .max(188, t('188OnlyAllowed'))
    });
    return validationSchema;
}

yup.addMethod(yup.string, 'equalTo', function (ref, msg) {
    //const { t, i18n } = useTranslation('common');
    // return yup.mixed().test(`validateMismatch`, function (val, ctx) {
    // const { path, createError } = this;

    // })
    return this.test({
        name: 'equalTo',
        exclusive: false,
        message: msg,
        params: {
            reference: ref.path
        },
        test: function (value) {
            return value === this.resolve(ref)
        }
    })
});

export default Validate;